import { type AxiosInstance } from "axios";

export const deleteManyReports = (api: AxiosInstance, customerId: string, reportIds: string[]) =>
  api.delete(`/v1/customers/${customerId}/analytics/reports/deleteMany`, { data: { ids: reportIds } });
